import { CompleteRegistration as CompleteRegistrationPage } from './complete-registeration/complete-registeration'
import { OnboardingFinished as OnboardingFinishedPage } from './onboarding-finished/onboarding-finished'
import { SignSLA as SignSLAPage } from './sign-sla/sign-sla'

export const CompleteRegistrationStack = {
  CompleteRegistrationPage,
  OnboardingFinishedPage,
  SignSLAPage,
}
